import React, { useEffect, useState, useRef } from 'react';
import './../calendar.css';
import BookItemsModel from '../components/client_dashboard/appointments/bookItemsModel';


function WeekCalendarDays(props) {
    console.log(props.appointments);
    const [weekDays, setWeekDays] = useState([]);

    const [showModal, setShowModal] = useState(false);

    const [modalContent, setModalContent] = useState("");

    const tableContentRef = useRef(null);



    useEffect(() => {
        generateWeekDays();
    }, [props.day]);

    useEffect(() => {
        // Attach scroll event listener to table content
        const tableContentElement = tableContentRef.current;
        tableContentElement.addEventListener('scroll', handleScroll);

        // Cleanup function
        return () => {
            tableContentElement.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        const tableContentElement = tableContentRef.current;
        if (tableContentElement.scrollTop + tableContentElement.clientHeight >= tableContentElement.scrollHeight) {
            // Scrolled to the bottom, load more items
            loadMoreItems();
        }
    };

    const loadMoreItems = () => {
        // Your logic to load more items
        // For example, fetch data from an API and append to weekDays
    };


    const generateWeekDays = () => {
        const startOfWeek = new Date(props.day);
        startOfWeek.setDate(props.day.getDate() - props.day.getDay()); // Start from Sunday

        const weekDays = [];

        for (let day = 0; day < 7; day++) {
            const currentDay = new Date(startOfWeek);
            currentDay.setDate(startOfWeek.getDate() + day);

            let timeSlots = [];
            for (let hour = 0; hour < 24; hour++) {
                for (let minute = 0; minute < 60; minute += 30) {
                    const currentTime = new Date(currentDay);
                    currentTime.setHours(hour);
                    currentTime.setMinutes(minute);
                    const formattedTime = currentTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
                    const appointments = props.appointments.filter(appointment => {
                        const appointmentDate = new Date(appointment.book_date);
                        return (
                            appointmentDate.getDate() === currentDay.getDate() &&
                            appointmentDate.getMonth() === currentDay.getMonth() &&
                            appointmentDate.getFullYear() === currentDay.getFullYear() &&
                            appointment.book_time === formattedTime
                        );
                    });

                    let bookItems = [];
                    appointments.map(appointment => {
                        let items = JSON.parse(appointment.book_items);
                        bookItems.push(...items);
                    });

                    timeSlots.push({
                        time: formattedTime,
                        appointments: appointments,
                        bookItems: bookItems
                    });
                }
            }

            let calendarDay = {
                currentMonth: (currentDay.getMonth() === props.day.getMonth()),
                date: new Date(currentDay),
                month: currentDay.getMonth(),
                number: currentDay.getDate(),
                selected: (currentDay.toDateString() === props.day.toDateString()),
                year: currentDay.getFullYear(),
                timeSlots: timeSlots
            };

            weekDays.push(calendarDay);
        }

        setWeekDays(weekDays);
    };

    const handleTimeSlotClick = (dayIndex, time) => {
        // Handle time slot click
    };
    const openModal = (content) => {
        console.log(content);
        setShowModal(true);
        setModalContent(content);
    }
    const closeModal = () => {

        setShowModal(false);
        setModalContent(() => "");
    };
    return (
        <>
            <div className="calender-weekdays d-flex justify-content-around">
                {weekDays.map((day, index) => (
                    <div key={day.date.toISOString()} className={"calendar-days" + (day.currentMonth ? " current" : "") + (day.selected ? " selected" : "")}>
                        <h3 className="mb-2">{day.number}</h3>
                    </div>
                ))}
            </div>

            <div className="week-calendar d-flex">
                {/* Render time slots */}
                <div className="time-slots">
                    {/* <div className="time-slot-label"></div> */}
                    <ul>
                        {[...Array(24)].map((_, index) => {
                            const formattedTime = new Date(2000, 0, 1, index, 0).toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
                            return <li key={index}>{formattedTime}</li>;
                        })}
                    </ul>
                </div>
                {/* Render calendar days */}

                <div className="table-content" ref={tableContentRef}>
                    {weekDays.map((day, index) => (
                        <div key={day.date.toISOString()} className={"calendar-day" + (day.currentMonth ? " current" : "") + (day.selected ? " selected" : "")}>
                            <ul>
                                {day.timeSlots.map((timeSlot, index) => (
                                    <li
                                        key={index}
                                        className={`time-slot  ${timeSlot.appointments.length} ${index}`}
                                        onClick={() => handleTimeSlotClick(index, timeSlot.time)}
                                    >
                                        <div className={timeSlot.appointments.length > 0 ? "appointment-info" : ""}>
                                            {timeSlot.appointments.map(appointment => (
                                                <div key={appointment.id} className="appointment" onClick={() => openModal(appointment)}>
                                                    <p>{appointment.book_time}</p>
                                                    <p className='text-capitalize'>{appointment.firstName}</p>
                                                    {/* {timeSlot.bookItems.map(bookItem => (
                                                    <div key={bookItem.id} className="book-item">
                                                        <p>{bookItem.name}</p>
                                                    </div>
                                                ))} */}

                                                </div>
                                            ))}
                                        </div>

                                    </li>
                                ))}
                            </ul>

                        </div>
                    ))}
                    <BookItemsModel show={showModal}
                        handleClose={closeModal} title="Booking Details"
                        content={modalContent} />
                </div>
            </div>
        </>

    );
}

export default WeekCalendarDays;